/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import { AuditLogsActions, AuditLogsResources } from 'modules/audit/interfaces';

export const getResourceTypeText = (
  resource_type: AuditLogsResources | string
) =>
  resource_type &&
  i18n.t(`LOGS_PAGE.RESOURCES.${resource_type.toUpperCase()}_KEY`);

export const getActionText = (action: AuditLogsActions | string) =>
  action && i18n.t(`LOGS_PAGE.ACTIONS.${action.toUpperCase()}_KEY`);

export const getFieldNameText = (field: string) => {
  const overwrittenFields = {
    active: i18n.t('STATUS_KEY'),
    active_directory: 'Active Directory',
    client_apps: i18n.t('APPLICATIONS_KEY'),
    migrate_reason: i18n.t('MIGRATION_REASON_KEY'),
    origin_company_name: i18n.t('ORIGIN_COMPANY_KEY'),
    destination_company_name: i18n.t('DESTINATION_COMPANY_KEY'),
    origin_partner_name: i18n.t('ORIGIN_PARTNER_KEY'),
    destination_partner_name: i18n.t('DESTINATION_PARTNER_KEY'),
    fictitious_email: i18n.t('EMAIL_FICTITIOUS_KEY'),
    first_name: i18n.t('NAME_KEY'),
    subdomain: i18n.t('PARTNER_PAGE.SUBDOMAIN_KEY'),
    title: i18n.t('PARTNER_PAGE.TITLE_KEY'),
    background_color: i18n.t('PARTNER_PAGE.LOGIN_BUTTONS_COLORS_KEY'),
    text_hover_color: i18n.t('PARTNER_PAGE.COLOR_HOVER_TEXT_KEY'),
    message_text_color: i18n.t('PARTNER_PAGE.MSG_COLORS_KEY'),
    primary_main_color: i18n.t('PARTNER_PAGE.HIGHLIGHT_COLOR_KEY'),
    primary_color: i18n.t('PARTNER_PAGE.PRIMARY_COLOR_KEY'),
    secondary_main_color: i18n.t('PARTNER_PAGE.MESSAGES_BUTTON_COLOR_KEY'),
    logo_background_color: i18n.t('PARTNER_PAGE.LOGO_BACKGROUND_COLOR_KEY'),
    header_login_font_size: i18n.t('PARTNER_PAGE.LOGIN_FONT_SIZE_KEY'),
    description_login_font_size: i18n.t(
      'PARTNER_PAGE.DESCRIPTION_FONT_SIZE_KEY'
    ),
    primary_contrast_text_color: i18n.t(
      'PARTNER_PAGE.ENVIRONMENT_TITLE_COLOR_KEY'
    ),
    image_login_background_color: i18n.t('PARTNER_PAGE.COLORS_BANNER_IMAGE'),
    enable_new_interface: i18n.t('PARTNER_PAGE.USE_NEW_FRONT_KEY'),
    logo: 'Logo',
    registration_source: i18n.t('REGISTER_THROUGH_KEY'),
    true: i18n.t('LOGS_PAGE.ACTIVE_KEY'),
    false: i18n.t('LOGS_PAGE.INACTIVE_KEY'),
    autosky: 'Autosky',
    cloud_providers_aws_owner_id: 'AWS Owner ID',
    cloud_providers_aws_role_arn: 'AWS Role arn',
    cloud_providers_aws_external_id: 'AWS External ID',
    client_apps_registration_source: i18n.t('REGISTER_THROUGH_KEY'),
    publication_can_block_old_instances: i18n.t(
      'PUBLICATIONS_OLD_INSTANCES_KEY'
    ),
    executed_instance_blocking_publications: i18n.t('TOTAL_PUBLICATIONS_KEY'),
    executed_instance_blocking_publications_daily: i18n.t(
      'TOTAL_DAILY_PUBLICATIONS_KEY'
    ),
    block_same_user_multiple_session: i18n.t(
      'DYNAMIC_FILTER.BLOCK_MULTIPLE_SESSION_KEY'
    ),
    control_licenses_by_limit: i18n.t('LICENSE_LIMIT_KEY'),
    user_connection_virtualizer: i18n.t('VIRTUALIZER_KEY'),
    increase_license_limit_each: i18n.t('INCREASE_LICENSES_BY_KEY'),
    warning_emails: i18n.t('EMAIL_KEY_WARNING_APPLICATION'),
    limit_instance_blocking_publications: i18n.t('MAX_PUBLICATIONS_KEY'),
    limit_instance_blocking_publications_daily: i18n.t(
      'MAX_DAILY_PUBLICATIONS_KEY'
    ),
    available_licenses_to_client: i18n.t('LICENSES_AVAILABLE_KEY'),
    connect_port: i18n.t('PRIMARY_PORT_KEY'),
    service_port: i18n.t('SECONDARY_PORT_KEY'),
    environment_allow_configuration: i18n.t(
      'USE_ENVIRONMENT_CONNECTION_TYPE_KEY'
    ),
    timezone: i18n.t('TIME_ZONE_KEY'),
    schedule_instances_blocking: i18n.t('SCHEDULED_BLOCK_INSTANCES_KEY'),
    bulk_created: i18n.t('BULK_CREATE_KEY'),
    bulk_removed: i18n.t('BULK_REMOVE_KEY'),
    bulk_updated: i18n.t('BULK_UPDATE_KEY'),
    time: i18n.t('TIME_SET_KEY'),
    aws: 'AWS',
    owner_id: 'AWS Owner ID',
    role_arn: 'AWS Role arn',
    external_id: 'AWS External ID',
    oci: 'OCI',
    flag_new_front: i18n.t('PARTNER_PAGE.ENABLE_NEW_FRONT_KEY'),
    deadline: i18n.t('PARTNER_PAGE.NEW_FRONT_MIGRATION_DEADLINE_KEY'),
    partner_deadline: i18n.t('PARTNER_PAGE.NEW_FRONT_MIGRATION_DEADLINE_KEY'),
    connection_weight: i18n.t('WEIGHT_KEY'),
    temperature_empty: i18n.t('EMPTY_KEY'),
    temperature_stopped: i18n.t('TURNED_OFF_KEY'),
    temperature_operational: i18n.t('OPERATIONAL_KEY'),
    provider_data_flavor: i18n.t('FLAVOR_KEY'),
    provider_data_subnet: 'Subnet',
    provider_data_security_group: i18n.t('SECURITY_GROUP_KEY'),
    provider_data_zone: i18n.t('ZONE_KEY'),
    provider_data_image_id: i18n.t('CUSTOM_IMAGE_KEY'),
    provider_data_boot_volume_id: i18n.t('BOOT_VOLUME_KEY'),
    provider_data_boot_volume_backup_id: i18n.t('BOOT_VOLUME_BACKUP_KEY'),
    provider_data_key_pair: i18n.t('KEY_PAIR_KEY'),
    provider_data_primary_zone: i18n.t('PRIMARY_ZONE_KEY'),
    provider_data_secondary_zone: i18n.t('SECONDARY_ZONE_KEY'),
    provider_data_credit_specification: i18n.t('CREDIT_SPECIFICATIONS_KEY'),
    provider_data_is_spot: 'Is spot',
    model_role: i18n.t('TYPE_KEY'),
    app_code: i18n.t('CODE_KEY'),
  };

  if (overwrittenFields[field]) {
    return overwrittenFields[field];
  }

  if (i18n.exists(`LOGS_PAGE.FIELDS.${field.toUpperCase()}_KEY`)) {
    return i18n.t(`LOGS_PAGE.FIELDS.${field.toUpperCase()}_KEY`);
  }

  if (i18n.exists(`${field.toUpperCase()}_KEY`)) {
    return i18n.t(`${field.toUpperCase()}_KEY`);
  }

  if (i18n.exists(field.toUpperCase())) {
    return i18n.t(field.toUpperCase());
  }

  return field;
};
